// extracted by mini-css-extract-plugin
export default {"versionInfoTable":"zzqaSLvk1H5uzyzXqyT1"};